import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the Filter Translation Manager View.
 * @extends JetView
 */
export default class FilterTranslationManagerView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing language and translation filters
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for selecting target language
                            name: 'ToLanguage',
                            label: "<span class='icon-user'></span>" + _('To Language'),
                            labelPosition: 'top',
                            placeholder: _('To Language'),
                            options: [
                                { id: 'Español', value: 'Español' },
                                { id: 'Ingles', value: 'Ingles' },
                            ],
                        },
                        {
                            view: 'richselect', // Dropdown for selecting translation state
                            name: 'IsTranslation',
                            label: "<span class='icon-state'></span>" + _('State'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'Unt', value: _('Untranslated') },
                                { id: 'Out', value: _('Out of Date') },
                            ],
                        },
                        {
                            view: 'text', // Input for searching by 'From Name'
                            name: 'ContainsFromName',
                            label: "<span class='icon-file-text1'></span>" + _('From Name'),
                            labelPosition: 'top',
                            placeholder: _('Contains Text'),
                        },
                    ],
                },
            ],
        };

        // Second left section for verification and abbreviation filters
        const left2 = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for verification status
                            name: 'IsVerified',
                            label: "<span class='icon-verified_user'></span>" + _('Verificado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                        },
                        {
                            view: 'text', // Input for abbreviation
                            name: 'Abbreviated',
                            label: _('Abreviado'),
                            labelPosition: 'top',
                            placeholder: _('Abreviado'),
                            invalidMessage: _('Abreviado is required'), // Validation message
                        },
                    ],
                },
            ],
        };

        // Upper section containing the first filter group
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 200 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left], // Including left section
                },
            ],
        };

        // Upper section containing the second filter group
        const upper_section2 = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 130 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left2], // Including second left section
                },
            ],
        };

        // Accordion section for advanced filters
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Header for advanced filters
                            body: {
                                padding: 10,
                                rows: [upper_section2], // Including upper section 2
                            },
                        },
                    ],
                },
            ],
        };

        // Button section for actions
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        {
                            minWidth: 200,
                            view: 'button', // Button to add translation
                            value: _('Añadir Traducción'),
                            type: 'form',
                            hidden: !devConfig.getPermAction(
                                'translationManagerAdd',
                                'Add', // Permission check for adding translation
                            ),
                            css: 'prm-translationManagerAdd',
                            click: () => {
                                this.app.callEvent('addMessage:button', [[]]); // Event for adding message
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button', // Button to clear filters
                            value: _('Limpiar'),
                            click: () => {
                                this.getRoot().clear(); // Clear the form
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button', // Button to consult translations
                            value: _('Consultar'),
                            type: 'form',
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get filter values
                                this.app.callEvent('translation:filter', [
                                    filterdata, // Trigger filter event with values
                                ]);
                            },
                        },
                    ],
                },
            ],
        };

        // Returning the main configuration for the form
        return {
            view: 'form',
            rows: [
                upper_section, // Including upper section
                buttons, // Including button section
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                // Additional initialization for small screens can be added here
            }
        });
    }
}

// FILE DOCUMENTED
